import { lazy } from 'react';

export const ChatsPage = lazy(() => import('./ChatsPage'));
